var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { PatientMeasurements, PatientMeasurementsProvider, } from "@madmedical/ui";
import { useGetTreatedPatientsQuery, useRouteNavigate } from "@madmedical/user";
import { rangeToDate, useDebounce } from "@madmedical/utils";
import { useCallback, useMemo, useState } from "react";
import { useParams } from "@madmedical/routing";
import { getAlertLevelChoices, getMetricTypeChoices, } from "@madmedical/medical";
import { useGetAggregatedMeasurementsQuery } from "../api";
const AggregatedMeasurements = () => {
    const { byPeriod } = useParams();
    const navigate = useRouteNavigate();
    const { data: patients } = useGetTreatedPatientsQuery();
    const [page, setPage] = useState(1);
    const [filter, setFilter] = useState({});
    const [search, setSearch] = useState();
    const debouncedSearch = useDebounce(search, 300, () => {
        setPage(1);
    });
    const { currentData } = useGetAggregatedMeasurementsQuery(Object.assign(Object.assign({ byPeriod: byPeriod !== null && byPeriod !== void 0 ? byPeriod : "day" }, filter), { search: debouncedSearch, page }));
    // TODO: row click should lead to day/week/month view of metric type
    const filterChoices = useMemo(() => {
        var _a;
        return ({
            patients: (_a = patients === null || patients === void 0 ? void 0 : patients.map(({ userId, fullName }) => {
                var _a;
                return ({
                    key: userId,
                    text: fullName,
                    isSelected: !!((_a = filter.patientUserIds) === null || _a === void 0 ? void 0 : _a.includes(userId)),
                });
            })) !== null && _a !== void 0 ? _a : [],
            metricTypes: getMetricTypeChoices(filter.metricTypes),
            alertLevels: getAlertLevelChoices(filter.alertLevel),
        });
    }, [filter, patients]);
    const handleFilterChange = useCallback((key, selected) => {
        setPage(1);
        // TODO: Why does type inference fail me?
        const diff = key === "metricTypes"
            ? { metricTypes: selected }
            : key === "alertLevels"
                ? { alertLevel: selected[0] }
                : key === "patients"
                    ? { patientUserIds: selected }
                    : {};
        setFilter((prevFilter) => (Object.assign(Object.assign({}, prevFilter), diff)));
    }, []);
    const handleSearchChange = (search) => {
        setSearch(search);
    };
    const handleEndReached = useCallback(() => {
        if (!currentData) {
            return;
        }
        const { currentPage, pageCount } = currentData.pagination;
        if (currentPage >= pageCount) {
            return;
        }
        setPage(currentPage + 1);
    }, [currentData]);
    const handlePeriodChange = (byPeriod) => {
        setPage(1);
        navigate("patients_measurements", { byPeriod });
    };
    const adaptedMeasurements = useMemo(() => {
        var _a;
        return (_a = currentData === null || currentData === void 0 ? void 0 : currentData.items.map((_a) => {
            var { dateTrunc, dateRange, opinionCount } = _a, aggregatedMeasurement = __rest(_a, ["dateTrunc", "dateRange", "opinionCount"]);
            return (Object.assign({ dateTrunc: new Date(dateTrunc), dateRange: rangeToDate(dateRange), evaluationCount: opinionCount }, aggregatedMeasurement));
        })) !== null && _a !== void 0 ? _a : [];
    }, [currentData === null || currentData === void 0 ? void 0 : currentData.items]);
    return (_jsx(PatientMeasurementsProvider, Object.assign({ value: {
            patientMeasurements: adaptedMeasurements,
            onSearchChange: handleSearchChange,
            filterChoices,
            onFilterChange: handleFilterChange,
        } }, { children: _jsx(PatientMeasurements, { period: byPeriod !== null && byPeriod !== void 0 ? byPeriod : "day", onEndReached: handleEndReached, onPeriodChange: handlePeriodChange }) })));
};
export default AggregatedMeasurements;
